import React from "react";
import {ff, form, HorizontalLoader, Icon, ModalActions} from "@mc/mc-legacy";
import {formValueSelector, reduxForm, SubmissionError} from "redux-form";
import {connect} from "react-redux";
import {Button, Card, CardBody, Col, Row} from "reactstrap";
import "./KontaktyNotifikaceForm.scss";
import SpravaKontaktuApi from "../../api/gen/core/SpravaKontaktuApi";
import * as TwoFactorType from "../../api/gen/core/TwoFactorType";
import {TypNotifikace} from "../../pages/ProfilePage";
import {toastr} from "react-redux-toastr";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";

const FormActions = form.FormActions;
const FormBody = form.FormBody;

class OverKontaktForm extends React.Component<any, { overenyEmail?: string; overenyTelefon?: string }> {
    static formName = "overKontaktForm";

    constructor(props) {
        super(props);
        this.state = {
            data: null,
        };
    }

    componentDidMount() {
        const {typ, kontakt, userId, onClose} = this.props;

        let api;
        switch (typ) {
            case TypNotifikace.EMAIL:
                api = SpravaKontaktuApi.getOvereniEmailKod({email: kontakt, ucetGuid: userId});
                break;
            case TypNotifikace.TELEFON:
                api = SpravaKontaktuApi.getOvereniTelefonKod({kontakt: kontakt});
                break;
        }

        api.then((data) => {
            this.setState({
                data,
            });
        })
            .catch(() => {
                onClose();
            });
    }

    customHandleSubmit = (e) => {
        const {typ, dispatch, kontakt, userId, handleSubmit} = this.props;

        handleSubmit((data) => {
            let api: Promise<unknown>;
            switch (typ) {
                case TypNotifikace.EMAIL:
                    api = SpravaKontaktuApi.updateOvereniEmailKod({kontakt: kontakt, kod: data.kod, ucetGuid: userId});
                    break;
                case TypNotifikace.TELEFON:
                    api = SpravaKontaktuApi.updateOvereniTelefonKod({kontakt: kontakt, kod: data.kod});
                    break;
            }

            return new Promise((resolve, reject) => {
                dispatch(ModalActions.showAsyncWaiting(
                    "",
                    <div style={{minWidth: 320}}>
                        <div className={"pb-2"}>{i18n(this.props.lang, "WaitingMessage")}</div>
                        <HorizontalLoader/>
                    </div>,
                    api,
                    (result: any) => {
                        switch (result.twoFactorType) {
                            case TwoFactorType.NONE:
                                /*onSubmit({
                                    ok: true,
                                });*/
                                resolve(undefined);
                                break;

                            default:
                                reject(new SubmissionError({
                                    kod: i18n(this.props.lang, "ProfilePage_notificationWrongCode"),
                                }));
                        }
                    },
                    (err) => {
                        reject(err);
                    }
                ))
            })
        })(e);
    };

    handleNovyKod = () => {
        const {kontakt, typ, change} = this.props;
        const {data} = this.state;

        let messageText;
        let api;
        switch (typ) {
            case TypNotifikace.EMAIL:
                messageText = <div>{i18n(this.props.lang, `TypNotifikace_Sent_${typ}`)}{" "}<span
                    className="text-nowrap">{kontakt}</span></div>;
                api = SpravaKontaktuApi.repeatEmail({repeatRequestCode: data.repeatRequestCode});
                break;
            case TypNotifikace.TELEFON:
                messageText = <div>
                    {i18n(this.props.lang, `TypNotifikace_Sent_${typ}`)}{" "}
                    <span className="text-nowrap">{kontakt}</span>
                </div>
                api = SpravaKontaktuApi.repeatTelefon({repeatRequestCode: data.repeatRequestCode});
                break;
        }

        api.then((result) => {
            toastr.success("", {component: messageText});
            change("kod", "");
            this.setState({
                data: result,
            });
        });
    };

    render() {
        const {kontakt, kod, typ, userId, submitting, onClose} = this.props;

        let icon;
        let info;
        let sendAgainLabel;
        switch (typ) {
            case TypNotifikace.EMAIL:
                sendAgainLabel = i18n(this.props.lang, `TypNotifikace_SendAgain_${typ}`);
                icon = <Icon className={"kontakt-icon kontakt-email"} icon={"envelope"}/>
                info =
                    <span>{i18n(this.props.lang, `TypNotifikace_SendAgain_Info_${typ}`, kontakt)}</span>
                break;
            case TypNotifikace.TELEFON:
                sendAgainLabel = i18n(this.props.lang, `TypNotifikace_SendAgain_${typ}`);
                icon = <Icon className={"kontakt-icon kontakt-telefon"} icon={"phone"}/>
                info =
                    <span>{i18n(this.props.lang, `TypNotifikace_SendAgain_Info_${typ}`, kontakt)}</span>
                break;
        }

        return (
            <form.Form className={"kontakty-notifikace-form"} onSubmit={this.customHandleSubmit}>
                <FormBody>
                    <h2 className={"mt-3 mb-3"}>{userId ? i18n(this.props.lang, "ProfilePage_emailVerificationTitle") : i18n(this.props.lang, "ProfilePage_notificationVerifyTitle")}</h2>
                    <Card className="mb-3">
                        <CardBody className={"pl-0"}>
                            <Row noGutters className={"m-1 align-items-center mb-3"}>
                                <Col xs={"2"} className={"d-flex align-items-center justify-content-center p-1"}>
                                    {icon}
                                </Col>
                                <Col className={"p-1"}>
                                    {info}
                                </Col>
                            </Row>
                            <Row className={"ml-1 mb-2 mt-3"}>
                                <Col xs={"12"} sm={1} className={"pr-1"}/>
                                <Col xs={"auto"} sm={"auto"} className={" ml-xs-0 ml-sm-4"}>
                                    <ff.Number
                                        autoComplete={"off"}
                                        style={{
                                            width: "108px",
                                        }}
                                        placeholder={"- - - -"}
                                        label={false}
                                        name="kod"
                                        disabled={submitting}
                                        maxLength={4}
                                    />
                                </Col>
                                <Col xs={"auto"} sm={"auto"} className={"d-flex align-items-center"}>
                                    <Button disabled={submitting} color="link" type="button" className="pr-0 pl-0"
                                            onClick={this.handleNovyKod}>
                                        {sendAgainLabel}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </FormBody>
                <FormActions submitButton={false} cancelButton={false}>
                    <Button className={"pl-3 pr-3"} color="primary" outline
                            onClick={onClose}>{i18n(this.props.lang, "button_cancel")}</Button>
                    <Button
                        className={"ml-2"}
                        color={"primary"}
                        type={"submit"}
                        disabled={submitting || !kod}
                    >
                        {userId ? i18n(this.props.lang, "ProfilePage_notificationVerify") : i18n(this.props.lang, "ProfilePage_notificationVerifyVerifyAndEnable")}
                    </Button>
                </FormActions>
            </form.Form>
        );
    }
}

function mapStateToProps(state, props) {
    const formName = props.form || OverKontaktForm.formName;
    const selector = formValueSelector(formName);
    return {
        kod: selector(state, "kod"),
    };
}

const reduxFormObj = reduxForm<any, any>({
    form: OverKontaktForm.formName
})(OverKontaktForm);
export default withLang(connect(mapStateToProps)(reduxFormObj));
